import { Link, useLocation } from 'react-router-dom';
import { labels } from '../data/i18n.js';
import { useLanguage } from '../hooks/useLanguage.jsx';
import LanguageToggle from './LanguageToggle.jsx';
import Logo from './Logo.jsx';

export default function Header({ forceIsBio = false, onNavClick, hideLogo = false }) {
  const location = useLocation();
  const { t } = useLanguage();
  const isBio = forceIsBio || location.pathname === '/bio';

  return (
    <header className="site-header">
      <div className="header-top">
      <nav className="nav-link">
        {isBio ? (
          <Link to="/" onClick={onNavClick}>
            {t(labels.navGallery)}
          </Link>
        ) : (
          <Link to="/bio" onClick={onNavClick}>
            {t(labels.navBio)}
          </Link>
        )}
      </nav>
        <LanguageToggle />
      </div>
      {!hideLogo && <Logo />}
    </header>
  );
}
